import "./instrument"
import React from "react"
import { createRoot } from "react-dom/client"

import { create } from "zustand"

import "./index.css"
import App from "./App"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"

// import reportWebVitals from './reportWebVitals';

export const useSWStore = create((set) => ({
  swInitialized: false,
  swUpdated: false,
  swRegistration: null,
}))

// A service worker update that lands right after the page loaded can be
// applied silently: the user has not started working yet, so reloading costs
// them nothing. Anything later surfaces the banner in Layout instead, because
// the whole point of that banner is to not yank a session away mid-task.
const AUTO_RELOAD_WINDOW = 10000
const AUTO_RELOAD_AT_KEY = "swAutoReloadAt"
// Guard against a worker that never activates: without this, every reload
// would find the same waiting worker and reload again, trapping the tab.
const AUTO_RELOAD_COOLDOWN = 60000

export const applySWUpdate = (registration) => {
  registration.waiting.postMessage({ type: "SKIP_WAITING" })
  setTimeout(() => {
    window.location.reload()
  }, 100)
}

// Claims the auto reload slot, so a worker that never activates cannot make
// every subsequent load reload itself. Returns false when the banner should be
// shown instead.
const claimAutoReload = () => {
  try {
    const lastAutoReloadAt = Number(sessionStorage.getItem(AUTO_RELOAD_AT_KEY))
    if (lastAutoReloadAt && Date.now() - lastAutoReloadAt < AUTO_RELOAD_COOLDOWN) return false
    sessionStorage.setItem(AUTO_RELOAD_AT_KEY, `${Date.now()}`)
    return true
  } catch (error) {
    console.warn("Failed to persist service worker auto reload state:", error)
    return false
  }
}

const onSWUpdate = (registration) => {
  // performance.now() is time since navigation start, i.e. how long this page
  // has been open — measured when the update arrives, not when Layout mounts.
  const justLoaded = performance.now() <= AUTO_RELOAD_WINDOW
  // Reloading mid OIDC callback would replay an already spent code
  const redirecting = /login_redirect/.test(window.location.pathname)

  if (registration?.waiting && justLoaded && !redirecting && claimAutoReload()) {
    applySWUpdate(registration)
    return
  }

  useSWStore.setState({ swUpdated: true, swRegistration: registration })
}

const root = createRoot(document.getElementById("root"))
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
)

serviceWorkerRegistration.register({
  onSuccess: reg => useSWStore.setState({ swInitialized: true, swRegistration: reg }),
  onUpdate: onSWUpdate,
})
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
